import { Plus, Copy, Trash2, DoorOpen, AppWindow, CheckCircle2, AlertCircle, MessageSquare } from "lucide-react";
import { ElevationThumb } from "@/components/ElevationThumb";

const Review = ({ s, tag }) => (!s?.count ? null : (
  <span className="flex items-center gap-1.5 mt-0.5" data-testid={`item-review-${tag.toLowerCase()}`}>
    {s.status === "approved" && <CheckCircle2 size={12} className="text-emerald-400" aria-label="Approved" />}
    {s.status === "changes" && <AlertCircle size={12} className="text-amber-400" aria-label="Changes requested" />}
    {s.open > 0 && <span className="flex items-center gap-0.5 text-[10px] font-mono font-semibold text-amber-300"><MessageSquare size={10} />{s.open}</span>}
  </span>
));

export const ItemList = ({ items, activeId, onSelect, onAdd, onDuplicate, onDelete, review = {} }) => (
  <aside className="w-full lg:w-[260px] shrink-0 border-r border-slate-800 bg-[#111827] flex flex-col min-h-0" data-testid="item-list">
    <div className="h-12 px-3 flex items-center border-b border-slate-800">
      <span className="font-mono text-xs uppercase tracking-wider text-slate-400">Openings · {items.length}</span>
      <button data-testid="add-window-btn" title="Add window" onClick={() => onAdd("window")} className="ml-auto h-7 w-7 grid place-items-center rounded text-slate-300 hover:bg-slate-800 hover:text-cyan-300"><AppWindow size={15} /></button>
      <button data-testid="add-door-btn" title="Add door" onClick={() => onAdd("door")} className="h-7 w-7 grid place-items-center rounded text-slate-300 hover:bg-slate-800 hover:text-cyan-300"><DoorOpen size={15} /></button>
    </div>
    <div className="flex-1 overflow-y-auto p-2 space-y-1">
      {items.map((it) => {
        const active = it.id === activeId;
        return (
          <div key={it.id} data-testid={`elevation-item-${it.tag.toLowerCase()}`} onClick={() => onSelect(it.id)}
            className={`group flex items-center gap-3 p-2 rounded-md cursor-pointer border transition-colors duration-150 ${active ? "bg-cyan-500/10 border-cyan-500/50" : "border-transparent hover:bg-slate-800/70"}`}>
            <div className="h-12 w-12 shrink-0 rounded bg-[#0B0F19] p-1"><ElevationThumb item={it} size={48} /></div>
            <div className="min-w-0 flex-1">
              <p className="font-mono text-sm font-semibold text-slate-100">{it.tag} <span className="text-[10px] uppercase text-slate-500">{it.type}</span></p>
              <p className="font-mono text-[11px] text-slate-400">{it.width}×{it.height} · ×{it.quantity || 1}</p>
              <Review s={review[it.id]} tag={it.tag} />
            </div>
            <div className="flex flex-col opacity-0 group-hover:opacity-100 transition-opacity">
              <button data-testid={`duplicate-item-${it.tag.toLowerCase()}`} onClick={(e) => { e.stopPropagation(); onDuplicate(it.id); }} className="p-1 text-slate-400 hover:text-cyan-300"><Copy size={13} /></button>
              <button data-testid={`delete-item-${it.tag.toLowerCase()}`} onClick={(e) => { e.stopPropagation(); onDelete(it.id); }} className="p-1 text-slate-400 hover:text-rose-400"><Trash2 size={13} /></button>
            </div>
          </div>
        );
      })}
      {items.length === 0 && (
        <button data-testid="add-first-item-btn" onClick={() => onAdd("window")} className="w-full p-4 rounded-md border border-dashed border-slate-700 text-sm text-slate-400 hover:border-cyan-500 hover:text-cyan-300 flex items-center justify-center gap-2">
          <Plus size={15} /> Add an elevation
        </button>
      )}
    </div>
  </aside>
);
